<div>
  <div class="ai-sweep-line"></div>
  @switch (uiMode) {
    @case (0) {
      <div>
        <app-loading [size]="'50px'" [style]="{'margin-top': '50px'}"></app-loading>
      </div>
    }
    @case (1) {
      <div>
        <div style="padding-top: 100px; text-align: center">
          <mat-icon style="font-size: 40px; width: 50px; height: 50px">speed</mat-icon>
          <h1 style="font-size: 2.2em">Studio dashboard</h1>
          <mat-label>studio version {{version}} |</mat-label>
          <mat-label>cloud version {{cloudVersion}}</mat-label>
        </div>
      </div>
    }
    @case (2) {
      <div>
        <div class="panel" style="padding-top: 100px">
          @if (studioType === EnumStudioType.LITE) {
            <div style="text-align: center">
              <div class="form-main">
                <mat-label class="header ">
                  <div style="text-align: center">
                    <button mat-raised-button class="downloadMainBut" (click)="download('studio_lite')" mat-button>
                      <fa-icon size='lg' class="web" [icon]="faEdit"></fa-icon>
                      <span style="font-size: 1.4em">Login to StudioLite</span>
                    </button>
                    <br/>
                    <br/>
                    <br/>
                    <div class="os-info-text" style="opacity: 0.7">
                      {{'general.liteLogin' | transloco}}
                    </div>
                  </div>
                </mat-label>
              </div>
            </div>
          }
          @if (studioType === EnumStudioType.PRO) {
            <div style="text-align: center">
              <p style="font-size: 1.2em">[ {{'general.proLogin4' | transloco}} ]</p>
              <p style="font-size: 1.2em">{{'general.proLogin5' | transloco}}...</p>
              <app-studio-download [proStudioOnly]="true"></app-studio-download>
            </div>
          }
        </div>
      </div>
    }
    @case (3) {
      <div>
        <!--<app-studio-ads></app-studio-ads>-->
        <app-scene-recents></app-scene-recents>
        <app-home-templates></app-home-templates>
      </div>
    }
    @case (4) {
      <div>
        <iframe [src]="embedCustomHomePage | pipeSafe:'resourceUrl'" width="100%" height="1000px">
          Sorry your browser does not support inline frames. please use latest Chrome browser.
        </iframe>
      </div>
    }
  }
</div>






